// extracted by mini-css-extract-plugin
export var addressFields = "_os-0";
export var animationContainer = "_os-1";
export var footer = "_os-2";
export var lineItems = "_os-3";
export var modalContent = "_os-4";
export var orderName = "_os-5";
export var strong = "_os-6";
export var warning = "_os-7";